var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{staticClass:"text-md-center"},[_vm._v("Hobbies")]),_c('Hobby',{attrs:{"hobby":'DnD',"hobby-points":_vm.dnd}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }